module.exports = __webpack_public_path__ + "static/media/HCMM436.30557e9a.jpg";